var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'rv-profile-update position-relative':true,
        'rv-profile-update-mobile': _vm.$detect == 'mobile'
    }},[(this.data.status == 1 && this.data.status_expire === 0)?_c('div',{class:{
            'profile-expired bg-white': true,
            'mb-3 px-3 py-10px': _vm.$detect == 'web',
            'p-3': _vm.$detect == 'mobile'
        }},[_c('span',{staticClass:"mb-0 fs-14px text-danger"},[_vm._v("Tin rao của bạn đã hết hạn. Vui lòng gia hạn để tiếp tục sử dụng")]),_c('button',{staticClass:"btn btn-danger btn-sm ml-3 px-4",on:{"click":function($event){return _vm.availability()}}},[_vm._v("Gia hạn ngay")])]):_vm._e(),_c('updateWeb',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }